import React from 'react';
import { Link } from 'react-router-dom';

const LnbComponent = props => (
    <nav className="lnb">
        <ul>
            <li className={props.tabIdx === 0 ? 'on' : ''}>
                <Link to='/about/introduction'>INTRODUCTION</Link>
            </li>
            <li className={props.tabIdx === 1 ? 'on' : ''}>
                <Link to='/about/sustainability'>SUSTAINABILITY</Link>
            </li>
            <li className={props.tabIdx === 2 ? 'on' : ''}>
                <Link to='/about/production'>PRODUCTION</Link>
            </li>
        </ul>
    </nav>
)

export default LnbComponent